import { Text } from "@chakra-ui/react";
import { StatusTag } from "src/components/DataDisplay/StatusTag";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { FORM_STATUS } from "src/constants";
import type { OrganizationError } from "src/hooks/useOrganization";
import { formatIsoDateToOrgDate } from "src/services/format";
import type * as GQL from "src/types/graphql";
import type { RemoteData } from "src/types/remoteData";
import { ColumnId } from "./constants";

type Row = {
  form: {
    status: GQL.form_status_enum;
    statusUpdatedAt: timestamptz | null;
  };
};

export function buildStatusColumnDef<T extends Row>({
  header,
}: {
  header?: string;
}): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.form.status,
    id: ColumnId.Status,
    header: header ?? "Status",
    tooltip: "Sort by status",
    cell: (props) => (
      <StatusTag status={FORM_STATUS[props.row.original.form.status]} />
    ),
  };
}

export function buildStatusDateColumnDef<T extends Row>({
  header,
  organization,
}: {
  organization: RemoteData<OrganizationError, GQL.Organization>;
  header?: string;
}): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.form.statusUpdatedAt,
    id: ColumnId.StatusDate,
    header: header ?? "Status Date",
    tooltip: "Sort by date last updated",
    cell: (props) => (
      <Text>
        {formatIsoDateToOrgDate(
          props.row.original.form.statusUpdatedAt || "",
          organization
        )}
      </Text>
    ),
  };
}
